var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Bell") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Bell",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(4.000000, 1.000000)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 12.5394816,
    cy: 29.0131593,
    rx: 1.01234883,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5394816,3.15793266 C9.29996536,3.15793266 7.84420775,4.67964103 7.68020724,4.82371978 C6.62331507,5.75332373 6.161684,6.85661164 5.97136242,8.25595177 L5.93491787,9.40266068 L5.85797936,11.6921311 C5.75050951,14.5123323 5.05326205,17.2814196 3.80898533,19.8296196 C3.68547878,20.0684351 3.58626859,20.3368558 3.45263855,20.5677765 L3.45263855,20.5677765 C3.36760124,20.71975 3.28053925,20.8894866 3.19145255,21.0375127 C2.93118975,21.4690314 2.61623532,21.8668956 2.25401754,22.2217215 L2.25401754,22.2217215 C1.12221155,23.3309305 0.593765462,23.9250086 0.188825932,25.4013223 L0.024825422,25.9282952 C-0.0364515502,26.1567904 0.0171893851,26.4000743 0.16936614,26.5838475 C0.321542894,26.7676207 0.554182145,26.8700573 0.796235227,26.8598729 L24.2037648,26.8598729 C24.4458179,26.8700573 24.6784571,26.7676207 24.8306339,26.5838475 C24.9828106,26.4000743 25.0364516,26.1567904 24.9751746,25.9282952 L24.8111741,25.4013223 C24.4062345,23.9250086 23.8696897,23.3309305 22.7338343,22.2177742 C22.3716165,21.8629483 22.0566621,21.4650841 21.7963993,21.0335653 C21.7073126,20.8855392 21.6202506,20.7158026 21.5352133,20.5638291 C21.4015832,20.3309347 21.3043977,20.0644877 21.1808912,19.8236986 C19.9377422,17.2758056 19.2405456,14.5075919 19.1318972,11.6881838 L19.059008,9.39476595 L19.0185141,8.26582018 C18.8302172,6.86253269 18.6560932,5.75529741 17.6012257,4.82371978 C17.4372252,4.67964103 15.7789978,3.15793266 12.5394816,3.15793266 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9488718,3.15793266 L14.9488718,2.36846009 C14.958134,1.74101959 14.7079225,1.13635456 14.2546485,0.69078856 C13.8013744,0.245222555 13.1831953,-0.0037356282 12.5394816,4.23799195e-05 C11.19763,4.23799195e-05 10.1098444,1.06041911 10.1098444,2.36846009 L10.1098444,3.15793266",
    id: "Path"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.6b805087f34ba4efecfbdaa89ec37bf1.svg";
export { ForwardRef as ReactComponent };